import { FILES } from '@/api'

const uploadUrl = () => {
  // O `?` no final e necessario: ao colar/enviar uma imagem, o CKEditor 4
  // concatena "&responseType=json" na URL sem checar se ja existe query
  // string (ele assume o formato historico ".../upload.php?type=Images").
  // Sem o `?`, a requisicao vai para "/v1/files&responseType=json" — rota
  // inexistente, que responde 404 (e, por nao passar pelo middleware de
  // CORS, aparece no console como erro de CORS).
  return process.env.VUE_APP_API_URL + FILES + '?'
}

export default {
  uploadUrl
}
